import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private _isSidebarOpen = signal<boolean>(true);
  readonly isSidebarOpen = computed<boolean>(() => this._isSidebarOpen());

  toggleSidebar() {
    this._isSidebarOpen.set(!this._isSidebarOpen());
  }
}
